






















import PublicPageContent from '@/components/PublicPageContent.vue'
import WithThemeTitle from '@/components/WithThemeTitle.vue'
import RenderWithTheme, { isPosteTheme } from '@/components/RenderWithTheme.vue'

export default {
  components: { WithThemeTitle, PublicPageContent, RenderWithTheme },
  computed: {
    isPosteTheme() {
      return isPosteTheme
    }
  }
}
